import { Typography } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

import { HeroPrice } from 'artkive/pages/Keepsakes'
import { colors } from 'artkive/utils/theme'

export const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  gap: 12,
  marginTop: 40,
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    gap: 16,
    marginTop: 16,
  },
}))

export const Prices = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 8,
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    gap: 4,
  },
}))

export const PriceRow = styled('div')({
  display: 'flex',
  alignItems: 'flex-end',
  gap: 8,
})

export const Price = styled(HeroPrice)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    lineHeight: '40px',
  },
}))

export const SizeText = styled(Typography)(({ theme }) => ({
  color: colors.grey[700],
  fontSize: '1rem',
  fontWeight: 700,
  lineHeight: 1.6,
  [theme.breakpoints.up('md')]: {
    color: colors.grey.dark,
  },
}))

export const AsteriskBox = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '4px',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    textAlign: 'left',
  },
}))
